import { schema } from 'normalizr';
import { SCHEMA_TYPE_USERS, SCHEMA_TYPE_ORGS } from '../constants/schemaTypes';

import omit from 'lodash/omit';

const orgSchema = new schema.Entity(SCHEMA_TYPE_ORGS);

const userSchema = new schema.Entity(
  SCHEMA_TYPE_USERS,
  {
    default_org: orgSchema,
  },
  {
    processStrategy: (entity) => omit(entity, ['api_key', 'login_history', 'logout_history']),
  },
);

export default userSchema;
